module.exports = __webpack_public_path__ + "static/img/hn.798b827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/hn.png
// module id = mkb/
// module chunks = 18